/**
 * "Claim anon points" intent — preserved across the signup redirect for anonymous users.
 *
 * Mirrors restaurantSaveIntent/menuScanIntent: an anonymous user on the points/rewards page taps
 * "Sign up to claim your N points", we stash this intent, route them through create-account, then
 * BaseLayout consumes it post-signup to send them to the points page (the claim itself runs
 * unconditionally on signup and is idempotent). Consuming the intent triggers an EARLY return in
 * BaseLayout's post-auth resume, which is what bypasses onboarding — exactly like the save flows.
 */
import { ROUTES } from './routes-helper'

const PENDING_POINTS_CLAIM_INTENT_KEY = 'pending_points_claim_intent'

export interface PendingPointsClaimIntent {
  returnRoute: string
}

export function getPendingPointsClaimIntent(): PendingPointsClaimIntent | null {
  try {
    const raw = sessionStorage.getItem(PENDING_POINTS_CLAIM_INTENT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PendingPointsClaimIntent
    return { returnRoute: parsed?.returnRoute ?? ROUTES.POINTS }
  } catch {
    return null
  }
}

export function setPendingPointsClaimIntent(
  intent: PendingPointsClaimIntent = { returnRoute: ROUTES.POINTS },
): void {
  try {
    sessionStorage.setItem(PENDING_POINTS_CLAIM_INTENT_KEY, JSON.stringify(intent))
  } catch {
    // ignore
  }
}

export function clearPendingPointsClaimIntent(): void {
  try {
    sessionStorage.removeItem(PENDING_POINTS_CLAIM_INTENT_KEY)
  } catch {
    // ignore
  }
}
